module.exports = __webpack_public_path__ + "i18n/es.09d2c8faca0ac660221e026e78eb85ba.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/es.json
// module id = 1057
// module chunks = 60